// extracted by mini-css-extract-plugin
export var header = "header-module--header--2GXhr";
export var eventsPC = "header-module--eventsPC--IsA1k";
export var img = "header-module--img--3plev";
export var eventsMobile = "header-module--eventsMobile--1GL7_";
export var logoWrapper = "header-module--logoWrapper--30m_2";
export var headerContent = "header-module--headerContent--15JXu";